import { Component } from '@angular/core';
@Component({
  selector: 'meddata-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: [],
})
export class MainLayoutComponent { }
